import { appName } from "./constants"

export const enUS = {
  // general
  'general.name': 'Name',
  'general.description': 'Description',
  'general.size': 'Size',
  'general.cancel': 'Cancel',
  'general.save': 'Save',
  'general.delete': 'Delete',
  'general.remove': 'Remove',
  'general.edit': 'Edit',
  'general.editor': 'Editor',
  'general.language': 'Language',
  'general.free': 'Free',
  'general.month': 'Month',
  'general.create': 'Create',
  'general.optional': 'Optional',
  'general.new': 'New',
  'general.submit': 'Submit',
  'general.overview': 'Overview',
  'general.created-at': 'Created At',
  'general.last-update': 'Last Update',
  'general.show': 'Show',
  'general.hide': 'Hide',
  'general.test': 'Test',
  'general.history': 'History',
  'general.input': 'Input',
  'general.result': 'Result',
  'general.type': 'Type',
  'general.download': 'Download',
  'general.replace': 'Replace',
  'general.user': 'User',
  'general.add': 'Add',
  'general.close': 'Close',
  'general.yes': 'True',
  'general.no': 'False',
  'general.project': 'Project',
  'general.upload': 'Upload',
  'general.config': 'Configuration',
  'general.update': 'Update',

  // components
  'table-attr.general.name': 'Name',
  'table-attr.general.size': 'Size',
  'table-attr.general.created-at': 'Created At',
  'table-attr.general.last-update': 'Last Update',
  'table-attr.auth.username': 'Username',
  'table-attr.auth.email-verified': 'Email Verified',
  'table-attr.database.items': 'Number of Items',
  'table-attr.storage.items': 'Number of files',
  'table-attr.file.type': 'Type',
  
  // home
  'home.back': 'Back to Home',
  'home.page-not-found': 'Oops! The page you are looking for does not exist.',
  'home.unauthorized': 'You do not have permission to access this page.',
  'home.title': `Make backend management easy for developers`,
  // home.landing
  'home.headline': 'Make backend management easy for developers',
  'home.subheadline': `${appName} provides a simple and intuitive interface and API to manage your users and databases.`,
  'home.get-started': 'Get Started',
  // home.features
  'home.features.title': ``,
  'home.features.statement': 'Choose the services you need, or use all features.',
  'home.features.auth': 'Authentication',
  'home.features.auth-description': 'Let users sign up, log in to your app. Customize your email templates, and setup password requirements.',
  'home.features.database': 'Database',
  'home.features.database-description': 'Store any information from your app. A simple API makes reading and writing data easier.',
  'home.features.storage': 'Storage',
  'home.features.storage-description': 'Store your app\'s images, documents or other types of files.',
  'home.features.function': 'Function',
  'home.features.function-description': 'Use function as your backend. Securely run your tasks.',
  // home.examples
  'home.examples.title': `Easy-to-use API to get started with`,
  'home.examples.statement': `Save your engineering time by using ${appName} API to manage your backend.`,
  'home.examples.view-docs': 'Read the docs',
  'home.examples.create': 'Create a project',
  'home.examples.setup': 'Setup your code',
  'home.examples.start': 'Start using',
  'home.examples.code-title': 'add_customer',
  // home.console
  'home.console.title': `Setup a project in minutes`,
  'home.console.statement': `${appName} provides a simple and intuitive interface and API to manage your users and databases.`,
  'home.console.how-to-start': 'How to start',
  'home.console.new-project': 'New Project',
  'home.console.projects': 'My Projects',
  'home.console.no-project': 'No project to display',
  'home.console.project.new-project.name-description': 'Name only contains letters, numbers and underscore(_)',
  'home.console.project.new-project.name-exists': 'Name already exists',
  'home.console.project.new-project.limit': 'You have reached the project limit',
  
  // auth
  'auth.sign-in': 'Sign in',
  'auth.sign-up': 'Sign up',
  'auth.sign-out': 'Sign out',
  'auth.forgot-password': 'Forgot password?',
  'auth.password': 'Password',
  'auth.username': 'Username',
  'auth.continue-with-google': 'Continue with Google',
  'auth.create-account': 'Create an account',
  'auth.sign-in-error': 'Incorrect username or password',
  'auth.sign-up-error.email-exists': 'Email already been used',
  'auth.sign-up-error.incorrect-code': 'Incorrect verification code',
  'auth.confirm-password': 'Confirm Password',
  'auth.verification-code': 'Verification Code',
  'auth.send-verification-code': 'Send Code',
  'auth.already-have-account': 'Already have an account? Sign in',
  
  // menu
  'menu.docs': 'Docs',
  'menu.home': 'Home',
  'menu.settings': 'Settings',
  'menu.pricing': 'Pricing',
  'menu.book-demo': 'Book a demo',
  
  // sidebar menu
  'sidebar-menu.project': 'Overview',
  'sidebar-menu.project.auth': 'Authentication',
  'sidebar-menu.project.database': 'Database',
  'sidebar-menu.project.storage': 'Storage',
  'sidebar-menu.project.function': 'Function',
  'sidebar-menu.project.metric': 'Metric',
  'sidebar-menu.project.config': 'Configuration',
  'sidebar-menu.settings.general': 'General',
  'sidebar-menu.settings.account': 'Account',
  'sidebar-menu.settings.plan-and-payments': 'Plan & Payments',
  'sidebar-menu.docs.get-started': 'Get Started',
  'sidebar-menu.docs.quickstart': 'Quickstart',
  'sidebar-menu.docs.services': 'Services',
  'sidebar-menu.docs.auth': 'Authentication',
  'sidebar-menu.docs.database': 'Database',
  'sidebar-menu.docs.storage': 'Storage',
  'sidebar-menu.docs.function': 'Function',
  'sidebar-menu.docs.examples': 'Examples',
  'sidebar-menu.docs.example-1': 'Get data using Function',

  // project
  'project.api-docs': 'API Docs',
  // project.overview
  'project.overview.project-info': 'Project info',
  'project.overview.project-description': 'Project description',
  'project.overview.admins': 'Authorized users',
  'project.overview.services': 'Services in use',
  'project.overview.users-count': '{{count}} users',
  'project.overview.auth.password.min-length': 'At least {{length}} characters',
  'project.overview.databases-count': '{{count}} databases',
  'project.overview.databases-size': 'Space in use',
  'project.overview.storages-count': '{{count}} storages',
  'project.overview.storages-size': 'Space in use',
  'project.overview.functions-count': '{{count}} functions',
  'project.overview.access-control': 'Access control',
  'project.overview.api-key': 'API Key',
  'project.overview.reveal-api-key': 'Reveal API Key',
  'project.overview.api-key.description': 'Your API key will only be displayed once. Before closing this dialog, copy and store it in a safe place.',
  'project.overview.api-key.invalid': 'Failed to show API key. If you lost your API key, you must create a new project.',
  // project.auth
  'project.auth.subject.template': `Verify your Email`,
  'project.auth.message.template.code': `Thanks for signing up, your verification code is {####}.`,
  'project.auth.message.template.link': `Thanks for signing up, click the link below to verify your Email: {##Verify Email##}.`,
  'project.auth.users': 'Users',
  'project.auth.users.title': '{{projectName}}\'s Users',
  'project.auth.users.empty': 'No user to display',
  'project.auth.users.add-user': 'Add user',
  'project.auth.users.add-user.limit': 'User limit reached, upgrade your plan to add more users',
  'project.auth.users.add-user.error': 'Failed adding user',
  'project.auth.users.add-user.user-exists': 'User already exists',
  'project.auth.users.add-user.invalid-params': 'Invalid password',
  'project.auth.users.delete-users': 'Delete users',
  'project.auth.users.delete-user-message': 'Delete {{count}} user',
  'project.auth.users.delete-users-message': 'Delete {{count}} users',
  'project.auth.password.min-length': 'Minimum length (6~99)',
  'project.auth.password.require-number': 'At least 1 number',
  'project.auth.password.require-symbol': 'At least 1 symbol',
  'project.auth.password.require-lowercase': 'At least 1 lowercase letter',
  'project.auth.password.require-uppercase': 'At least 1 uppercase letter',
  'project.auth.password': 'Password requirements',
  'project.auth.template': 'Message template',
  'project.auth.template.confirm-with-code': 'Use verification code',
  'project.auth.template.confirm-with-link': 'Use link',
  'project.auth.template.subject': 'Subject',
  'project.auth.template.message': 'Message',
  'project.auth.template.message-with-placeholder': 'Message (must contain {{placeholder}})',
  // project.database
  'project.database.all-tables': 'All tables',
  'project.database.no-database': 'No table to display',
  'project.database.total-size': 'Total size',
  'project.database.delete-databases': 'Delete tables',
  'project.database.delete-database-message': 'Delete selected tables',
  'project.database.add-database': 'Add a table',
  'project.database.add-database.limit': 'Table limit reached, upgrade your plan to add more tables',
  'project.database.no-item': 'No item to display',
  'project.database.all-items': 'All items',
  'project.database.export-to': 'Export to',
  'project.database.import-from': 'Import from',
  'project.database.delete-items': 'Delete items',
  'project.database.delete-item-message': 'Delete {{count}} item',
  'project.database.delete-items-message': 'Delete {{count}} items',
  'project.database.add-item': 'Add item',
  'project.database.edit-item': 'Edit item',
  'project.database.attr.add': 'Add value',
  'project.database.attr.string': 'Text',
  'project.database.attr.number': 'Number',
  'project.database.attr.boolean': 'True/False',
  'project.database.attr.list': 'List',
  'project.database.attr.map': 'Map',
  // project.storage
  'project.storage.all-storages': 'All storages',
  'project.storage.no-storage': 'No storage to display',
  'project.storage.total-size': 'Total size',
  'project.storage.delete-storages': 'Delete storages',
  'project.storage.delete-storage-message': 'Delete selected storages',
  'project.storage.add-storage': 'Add a storage',
  'project.storage.add-storage.limit': 'Storage limit reached, upgrade your plan to add more storages',
  'project.storage.no-item': 'No file to display',
  'project.storage.all-files': 'All files',
  'project.storage.delete-files': 'Delete files',
  'project.storage.delete-file-message': 'Delete {{count}} file',
  'project.storage.delete-files-message': 'Delete {{count}} files',
  'project.storage.same-file-name': 'File name already exists',
  'project.storage.same-file-name-message': 'File name already exists, do you want to replace the original file?',
  'project.storage.download-files': 'Download files',
  'project.storage.download-file-message': 'Download {{count}} file',
  'project.storage.download-files-message': 'Download {{count}} files',
  'project.storage.upload-files': 'Upload files',
  'project.storage.uploading': 'Uploading',
  // project.function
  'project.function.all-functions': 'All functions',
  'project.function.no-function': 'No function to display',
  'project.function.add-function': 'Add a function',
  'project.function.add-function.limit': 'Function limit reached, upgrade your plan to add more functions',
  'project.function.add-function.use-template': 'Use template',
  'project.function.add-function.use-template.sign-in': 'Sign in with the given username and password in request body',
  'project.function.add-function.use-template.get-item': 'Get an item from a table using the given ID and return the item',
  'project.function.delete-functions': 'Delete functions',
  'project.function.delete-function-message': 'Delete selected functions',
  'project.function.size-warning': 'The size of the function has reached the limit',
  'project.function.config': 'Configuration',
  'project.function.test.title': 'Test',
  'project.function.test.template': 'Test examples',
  'project.function.test.template-message': 'Use the following template to test:',
  'project.function.test.http-method': 'HTTP method',
  'project.function.test.query-params': 'Query parameters',
  'project.function.test.headers': 'Headers',
  'project.function.test.add-header': 'Add header',
  'project.function.test.body': 'Body',
  'project.function.test.response': 'Response',
  'project.function.test.status-code': 'Status code',
  'project.function.test.response.body': 'Response body',
  'project.function.config.id-description': `When you use ${appName} API, you will need to use the ID to specify the function to execute`,
  'project.function.config.id-regenerate': 'Change ID',
  'project.function.config.id-regenerate.description': 'Generate a new ID for this function',
  'project.function.config.change-expiration': 'Change expiration',
  'project.function.config.auto-save': 'Auto save',
  'project.function.config.auto-save.description': 'Automatically save the function after a period of time',
  'project.function.env': 'Environment variables',
  // project.metric
  'project.metric.api-requests': 'API requests',
  'project.metric.no-data': 'No data to display',
  'project.metric.this-month': 'This month',
  // project.config
  'project.config.title': 'Configuration',
  'project.config.general.title': 'General',
  'project.config.danger-zone.title': 'Danger zone',
  'project.config.danger-zone.delete-project': 'Delete project',
  'project.config.danger-zone.delete-project-warning': 'Deleting the project will delete all data associated with it.',
  'project.config.danger-zone.delete-project-message': `Delete project <span class='font-bold'>{{name}}</span>`,

  // settings
  'settings.general.title': 'General',
  'settings.general.delete-photo': 'Remove photo',
  'settings.general.delete-photo-message': 'Are you sure you want to remove your photo?',
  'settings.account.title': 'Account',
  'settings.plan-and-payments.title': 'Plan & Payments',
  'settings.plan-and-payments.no-plan': 'You don\'t have a subscription plan yet',
  'settings.plan-and-payments.cancel-plan': 'Cancel plan',
  'settings.plan-and-payments.payment-methods': 'Payment methods',
  'settings.plan-and-payments.no-payment-methods': 'No payment methods',
  'settings.plan-and-payments.add-payment-method': 'Add payment method',
  'settings.plan-and-payments.billing-history': 'Billing history',
  'settings.plan-and-payments.view-billing-history': 'View billing history',

  // pricing
  '/month': 'Month',
  '/year': 'Year',
  'pricing.monthly': 'Monthly',
  'pricing.yearly': 'Yearly',
  'pricing.save': 'Save {{percent}}%',
  'pricing.title': 'Pricing',
  'pricing.free': 'Free',
  'pricing.upgrade': 'Upgrade',
  'pricing.free-description': 'Easy to get started, for beginners or students',
  'pricing.starter-description': 'For new startups or solo entrepreneurs',
  'pricing.pro-description': 'More space and flexibility, perfect for businesses',
  'pricing.your-current-plan': 'Your current plan',
  'pricing.upgrade-starter': `Start using ${appName} Starter`,
  'pricing.upgrade-pro': `Start using ${appName}`,
  'pricing.free-limit.apps': '1 Project',
  'pricing.free-limit.users': '50 Users / Project',
  'pricing.free-limit.databases': '2 Database tables / Project',
  'pricing.free-limit.databases-space': '10 MB of total database space',
  'pricing.free-limit.storages': '100 MB of total storage space',
  'pricing.free-limit.api': `5000 API requests / Month`,
  'pricing.free-limit.functions': `5 Functions / Project`,
  'pricing.free-limit.function-size': `10 KB maximum size per function`,
  'pricing.free-limit.ai': `Limited AI usage`,
  'pricing.pro-limit.plus': 'Standard support',
  'pricing.pro-limit.apps': '10 Projects',
  'pricing.pro-limit.users': '1,000,000 Users / Project',
  'pricing.pro-limit.databases': 'Unlimited database tables / Project',
  'pricing.pro-limit.databases-space': '10 GB of total database space',
  'pricing.pro-limit.storages': '20 GB of total storage space',
  'pricing.pro-limit.api': `1,000,000 API requests / Month`,
  'pricing.pro-limit.functions': `Unlimited functions / Project`,
  'pricing.pro-limit.function-size': `50 KB maximum size per function`,
  'pricing.pro-limit.ai': `Unlimited AI usage`,

  // docs
  'docs.menu': 'What\'s in this page',
  'docs.code-title.setup': `Setup ProjectManager`,
  // docs.get-started
  'docs.get-started.menu.title': 'Quick start',
  'docs.get-started.menu.create-project': 'Create a project',
  'docs.get-started.menu.install-sdk': 'Install SDK',
  'docs.get-started.menu.setup-manager': 'Setup ProjectManager',
  'docs.get-started.menu.next-step': 'Next step',
  'docs.get-started.section-1': `<p>${appName} provides a simple interface and API to manage your users and databases. Follow the guide to get started.</p>`,
  'docs.get-started.section-2': `<p>Once logged in, you can create a new project on the main page. And after creating a project, you will find the <span class='text-primary'>project ID</span> and the <span class='text-primary'>API key</span> in the project overview, which you can use in your code later to access the project's services.</p>`,
  'docs.get-started.section-3': `<p>When you have the project ID and API key, you can use the API to access your project's services in your backend code. In order to use the API, you need to install the SDK to get started. But if you use <span class="text-primary">${appName} Functions</span> to manage your project backend, you do not need to install the SDK.</p>`,
  'docs.get-started.section-4': `<p>Setup a <code>ProjectManager</code> and pass in the <code>project ID</code> and <code>API key</code> of your project. The manager will be used to access the project's services.</p>`,
  'docs.get-started.section-5': `<p>After setting up the manager, you can start using it with the services you need:</p>`,
  'docs.get-started.code-title.install': 'Install SDK',
  // docs.auth
  'docs.auth.menu.title': 'Use API to authenticate users',
  'docs.auth.menu.signup': 'Sign up',
  'docs.auth.menu.confirm-signup': 'Confirm sign up',
  'docs.auth.menu.signin': 'Sign in',
  'docs.auth.menu.forgot-password': 'Forgot password',
  'docs.auth.menu.delete-user': 'Delete user',
  'docs.auth.section-1': `<p>To use API to authenticate users, you need to:<br /><span class='mx-1'>1. Create a project, which will create a default authentication system for you</span><br /><span class='mx-1'>2. Modify the configuration according to your needs like password requirements, email messages.</span><br /><span class='mx-1'>3. Set up a <code>ProjectManager</code> and pass in the <code>project ID</code> and <code>API key</code> of your project.</span><br /><span class='mx-1'>4. Use <code>manager.auth</code> to access the authentication system.</span></p>`,
  'docs.auth.section-2': `<p>You can use <code>signUp</code> to create a new user, and the user receives an email for verification.</p>`,
  'docs.auth.section-3': `<p>After receiving the verification email, the user can pass in the verification code in your app. And you can call the <code>confirmSignUp</code> method to confirm the user. Then the user will be marked as verified in your authentication system.</p>`,
  'docs.auth.section-4': `<p>A verified user can use <code>signIn</code> to log in.</p>`,
  'docs.auth.section-5': `<p>If a user forgets their password, they can use the <code>forgotPassword</code> method to send a verification code to the user's email. Then <code>confirmForgotPassword</code> can be used to reset the password.</p>`,
  'docs.auth.section-6': `<p style="margin-top: 2rem;">After passing in the verification code and the new password, the user's password will be updated.</p>`,
  'docs.auth.section-7': `<p>In your app, you can also use <code>deleteUser</code> to delete a user.</p>`,
  'docs.auth.code-title.signup': `Sign up a new user`,
  'docs.auth.code-title.confirm-signup': `Confirm sign up`,
  'docs.auth.code-title.signin': `Sign in`,
  'docs.auth.code-title.forgot-password': `Forgot password`,
  'docs.auth.code-title.reset-password': `Reset password`,
  'docs.auth.code-title.delete-user': `Delete user`,
  // docs.database
  'docs.database.menu.title': 'Access your database',
  'docs.database.menu.add': 'Add a new item',
  'docs.database.menu.get': 'Retrieve items',
  'docs.database.menu.delete': 'Delete items',
  'docs.database.menu.update': 'Update items',
  'docs.database.section-1': `<p>To use API to access your database, you need to:<br /><span class='mx-1'>1. Create a database in your project</span><br /><span class='mx-1'>2. Set up a <code>ProjectManager</code></span><br /><span class='mx-1'>3. Use <code>manager.database</code> to access the database</span></p>`,
  'docs.database.section-2': `<p>Use <code>createItem</code> and specify the database name, you can create a new item in the database. The item must contain an <code>id</code>. If the item's <code>id</code> already exists in the table, an error will be returned. The following example shows how to create a new item:</p>`,
  'docs.database.section-3': `<p><code>getItem</code> allows you to retrieve an item from the database using <code>id</code>. The following example shows how to retrieve an item:</p>`,
  'docs.database.section-4': `<p style="margin-top: 2rem;">Using <code>getItems</code>, you can also retrieve multiple items in the database, you can specify the <code>limit</code> and the <code>offset</code>. If you don't specify them, the default limit is 100 and the default offset is 0. Here's an example:</p>`,
  'docs.database.section-5': `<p style="margin-top: 2rem;">Or use <code>findItems</code> to retrieve items that match the specified conditions. <code>conditions</code> represents the conditions for the returning items, as shown in the following example:</p>`,
  'docs.database.section-6': `<p>The following results show that only items that match the conditions are returned:</p>`,
  'docs.database.section-7': `<p>To delete an item, use <code>deleteItems</code>. The following example shows how to delete items:</p>`,
  'docs.database.section-8': '<p>To change part of an item, use <code>updateItem</code>. <code>changes</code> contains the parameters to be changed, as shown in the example:</p>',
  'docs.database.section-8.before-update': `Before update:`,
  'docs.database.section-8.after-update': `After update:`,
  'docs.database.code-title.create-item': `Add a new item to Users`,
  'docs.database.code-title.get-item': `Get an item from Users`,
  'docs.database.code-title.get-all-items': `Get all items from Users`,
  'docs.database.code-title.get-some-items': `Get some items from Users`,
  'docs.database.code-title.delete-item': `Delete an item`,
  'docs.database.code-title.update-item': `Change some attributes of user1`,
  // docs.storage
  'docs.storage.menu.title': 'Use API to access files in your storage',
  'docs.storage.menu.upload-file': 'Upload a file',
  'docs.storage.menu.download-file': 'Get file content',
  'docs.storage.menu.delete-file': 'Delete a file',
  'docs.storage.section-1': `<p>To use API to access files in your storage, you need to:<br /><span class='mx-1'>1. Create a storage in your project</span><br /><span class='mx-1'>2. Set up a<code>ProjectManager</code></span><br /><span class='mx-1'>3. Use <code>manager.storage</code> to access the storage</span></p>`,
  'docs.storage.section-2': `<p>To upload a file to your storage, you first use <code>getUploadUrl</code> to get the upload URL. The returned URL can be used to upload a file in your frontend:</p>`,
  'docs.storage.section-3': `<p>To get the file content, you also get a URL using <code>getFileContentUrl</code> method, and then use the URL to get the file content:</p>`,
  'docs.storage.section-4': `<p>You can also use <code>deleteFile</code> to delete a file, as shown in the following example:</p>`,
  'docs.storage.code-title.upload': `Upload a file`,
  'docs.storage.code-title.get-file-content': `Return as a Blob object`,
  'docs.storage.code-title.delete': `Delete a file`,
  'docs.storage.code-example.blob-object': `Blob {size: 12345, type: "image/png"}`,
  // docs.function
  'docs.function.menu.title': `Use ${appName} Function to run your backend`,
  'docs.function.menu.setup-code': 'Set up your function',
  'docs.function.menu.use-api': `Use ${appName} API in your function`,
  'docs.function.menu.call-function': 'Call function from anywhere',
  'docs.function.section-1': `<p>${appName} Function allows you to run your backend securely in your project. Create a function, and follow the guide to set up.</p>`,
  'docs.function.section-2': `<p>When you create a function, you will get a Node.js template as the following example.<br />In <code>main</code> function, define your tasks and the result to return.</p>`,
  'docs.function.section-3': `<p>You can use a function to authenticate users and manage your database. For example, you can use the function to get an item from a database, such as the following example:</p>`,
  'docs.function.section-4': `<p>After you set up the function, you can use it in your frontend. The following example shows how to call the function using <span class="text-primary">REST API</span>, with the content type set to <span class="text-primary">application/json</span>.<br />The URL is <span class="text-primary">https://api.tranfoo.com/<span class="font-bold">YOUR_PROJECT_ID</span>/function/<span class="font-bold">YOUR_FUNCTION_ID</span></span></p>`,
  'docs.function.section-5': `<p class="mt-8">See how to use a function in a React app:</p>`,
  'docs.function.code-title.setup-code': 'Set up your function',
  'docs.function.code-title.use-api': `Use ${appName} API in your function`,
  'docs.function.code-title.call-function': 'Using REST API to call the function',
  'docs.function.code-example.get-param': 'Get `tableName` and `id` from params',
  'docs.function.code-example.get-data': 'Use `manager.database.getItem` to get data',
  'docs.function.code-example.return-data': 'Return the item',
  // docs.example-1
  'docs.example-1.menu.title': 'Get data using Function',
  'docs.example-1.menu.database': 'Example: Get data from database',
  'docs.example-1.menu.setup-function': 'Set up your function',
  'docs.example-1.menu.call-function': 'Call function from a React app',
  'docs.example-1.section-1': `<p>This example shows how to get data from a database using ${appName} Function. And then call the function in a React app.</p>`,
  'docs.example-1.section-2': `<p>The following is an example database <span class="font-bold">customers</span> with 3 items.</p>`,
  'docs.example-1.section-3': `<p>Create a function to get all items in a database.</p>`,
  'docs.example-1.section-4': `<p>In the following React app, we copy the project ID and function ID, and paste them in.<br/><code>items</code> represents all items, and after calling the function with ${appName}'s REST API, we use <code>setItems</code> to update the items with the returned data.</p>`,
  'docs.example-1.section-5': `<p class="mt-8">After getting the data, display it on the screen, as shown in the following screen:</p>`,
  'docs.example-1.code-title.setup-function': 'get_all_items',
  'docs.example-1.code-title.call-function': 'React app',
  'docs.example-1.code-example.get-param': 'Get `tableName` from params',
  'docs.example-1.code-example.get-data': 'Use `manager.database.getAllItems` to get all items',
  'docs.example-1.code-example.return-data': 'Return the items',
  'docs.example-1.code-example.use-state': '`items` represents all items',
  'docs.example-1.code-example.fetch-data': 'Use fetch to call REST API and specify `tableName`',
  'docs.example-1.code-example.set-state': 'Update `items` with returned data',
}

export const zhTW = {
  // general
  'general.name': '名稱',
  'general.description': '描述',
  'general.size': '大小',
  'general.cancel': '取消',
  'general.save': '儲存',
  'general.delete': '刪除',
  'general.remove': '移除',
  'general.edit': '編輯',
  'general.editor': '編輯器',
  'general.language': '語言',
  'general.free': '免費',
  'general.month': '月',
  'general.create': '建立',
  'general.optional': '選填',
  'general.new': '新增',
  'general.submit': '送出',
  'general.overview': '總覽',
  'general.created-at': '建立時間',
  'general.last-update': '最後更新',
  'general.show': '顯示',
  'general.hide': '隱藏',
  'general.test': '測試',
  'general.history': '歷史紀錄',
  'general.input': '輸入',
  'general.result': '結果',
  'general.type': '類型',
  'general.download': '下載',
  'general.replace': '取代',
  'general.user': '使用者',
  'general.add': '新增',
  'general.close': '關閉',
  'general.yes': '是',
  'general.no': '否',
  'general.project': '專案',
  'general.upload': '上傳',
  'general.config': '設置',
  'general.update': '更新',

  // components
  'table-attr.general.name': '名稱',
  'table-attr.general.size': '大小',
  'table-attr.general.created-at': '建立時間',
  'table-attr.general.last-update': '最後更新',
  'table-attr.auth.username': '使用者名稱',
  'table-attr.auth.email-verified': 'Email 已驗證',
  'table-attr.database.items': '項目數量',
  'table-attr.storage.items': '檔案數量',
  'table-attr.file.type': '類型',
  
  // home
  'home.back': '回到首頁',
  'home.page-not-found': '哎呀！你要找的頁面不存在。',
  'home.unauthorized': '你沒有權限訪問此頁面。',
  'home.title': `輕鬆上手的後端管理工具`,
  // home.landing
  'home.headline': '輕鬆上手的後端管理工具',
  'home.subheadline': `${appName} 提供簡單直觀的介面與 API 來管理你的使用者與資料庫。`,
  'home.get-started': '開始使用',
  // home.features
  'home.features.title': ``,
  'home.features.statement': '在專案中選擇你需要的服務，或使用所有功能',
  'home.features.auth': '身份驗證',
  'home.features.auth-description': '讓用戶註冊、登入你的應用程式，客製化你的電子郵件範本、用戶密碼要求',
  'home.features.database': '資料庫',
  'home.features.database-description': '儲存你的應用程式的任何資訊，簡易的 API 讓讀寫資料更容易',
  'home.features.storage': '檔案管理',
  'home.features.storage-description': '儲存你的應用程式的圖片、文件或其他檔案',
  'home.features.function': '函式',
  'home.features.function-description': '使用函式代理你的後端，安全地執行你的任務',
  // home.examples
  'home.examples.title': `容易上手的 API`,
  'home.examples.statement': `運用簡短的程式碼來節省開發的時間。`,
  'home.examples.view-docs': '查看說明文件',
  'home.examples.create': '建立專案',
  'home.examples.setup': '設置你的程式碼',
  'home.examples.start': '開始使用',
  'home.examples.code-title': 'add_customer',
  // home.console
  'home.console.title': `在幾分鐘內建立好你的專案`,
  'home.console.statement': `${appName} 提供了一個簡單的介面和 API 來管理你的使用者與資料庫。`,
  'home.console.how-to-start': '如何開始',
  'home.console.new-project': '新增專案',
  'home.console.projects': '我的專案',
  'home.console.no-project': '目前沒有專案',
  'home.console.project.new-project.name-description': '名稱只能包含字母、數字與 "_"',
  'home.console.project.new-project.name-exists': '名稱已經存在',
  'home.console.project.new-project.limit': '你的帳號已達到專案數量上限',
  
  // auth
  'auth.sign-in': '登入',
  'auth.sign-up': '註冊',
  'auth.sign-out': '登出',
  'auth.forgot-password': '忘記密碼？',
  'auth.password': '密碼',
  'auth.username': '使用者名稱',
  'auth.continue-with-google': '使用 Google 帳號登入',
  'auth.create-account': '註冊新帳號',
  'auth.sign-in-error': '帳號或密碼錯誤',
  'auth.sign-up-error.email-exists': '這個 Email 已經被註冊',
  'auth.sign-up-error.incorrect-code': '驗證碼錯誤',
  'auth.confirm-password': '確認密碼',
  'auth.verification-code': '驗證碼',
  'auth.send-verification-code': '發送驗證碼',
  'auth.already-have-account': '已經有帳號了嗎？登入',
  
  // menu
  'menu.docs': '說明文件',
  'menu.home': '首頁',
  'menu.settings': '設定',
  'menu.pricing': '方案與定價',
  'menu.book-demo': '預約 Demo',
  
  // sidebar menu
  'sidebar-menu.project': '專案總覽',
  'sidebar-menu.project.auth': '身份驗證',
  'sidebar-menu.project.database': '資料庫',
  'sidebar-menu.project.storage': '檔案庫',
  'sidebar-menu.project.function': '函式',
  'sidebar-menu.project.metric': '已使用數據',
  'sidebar-menu.project.config': '專案設定',
  'sidebar-menu.settings.general': '設定',
  'sidebar-menu.settings.account': '帳號',
  'sidebar-menu.settings.plan-and-payments': '方案與付款',
  'sidebar-menu.docs.get-started': '開始',
  'sidebar-menu.docs.quickstart': '快速開始',
  'sidebar-menu.docs.services': '服務項目',
  'sidebar-menu.docs.auth': '身份驗證',
  'sidebar-menu.docs.database': '資料庫',
  'sidebar-menu.docs.storage': '檔案庫',
  'sidebar-menu.docs.function': '函式',
  'sidebar-menu.docs.examples': '範例',
  'sidebar-menu.docs.example-1': '使用函式獲取資料',

  // project
  'project.api-docs': 'API 說明',
  // project.overview
  'project.overview.project-info': '專案資訊',
  'project.overview.project-description': '專案描述',
  'project.overview.admins': '有權限的使用者',
  'project.overview.services': '已使用的服務項目',
  'project.overview.users-count': '{{count}} 個使用者',
  'project.overview.auth.password.min-length': '至少 {{length}} 個字元',
  'project.overview.databases-count': '{{count}} 個資料庫',
  'project.overview.databases-size': '已使用空間',
  'project.overview.storages-count': '{{count}} 個檔案庫',
  'project.overview.storages-size': '已使用空間',
  'project.overview.functions-count': '{{count}} 個函式',
  'project.overview.access-control': '專案權限',
  'project.overview.api-key': 'API 金鑰',
  'project.overview.reveal-api-key': '顯示 API 金鑰',
  'project.overview.api-key.description': '你的 API 金鑰只會顯示一次，在關閉此對話框之前複製並存放在安全的地方。',
  'project.overview.api-key.invalid': '無法顯示 API 金鑰，若你遺失了你的 API 金鑰，你必須重新建立一個專案。',
  // project.auth
  'project.auth.subject.template': `驗證你的 Email`,
  'project.auth.message.template.code': `感謝你的註冊，你的驗證碼是 {####}。`,
  'project.auth.message.template.link': `感謝你的註冊，點擊連結來驗證你的 Email: {##Verify Email##}。`,
  'project.auth.users': '使用者',
  'project.auth.users.title': '{{projectName}} 的使用者',
  'project.auth.users.empty': '目前沒有使用者',
  'project.auth.users.add-user': '新增使用者',
  'project.auth.users.add-user.limit': '使用者數量已達上限，升級方案以新增更多使用者',
  'project.auth.users.add-user.error': '新增失敗',
  'project.auth.users.add-user.user-exists': '使用者已經存在',
  'project.auth.users.add-user.invalid-params': '密碼不符合要求',
  'project.auth.users.delete-users': '刪除使用者',
  'project.auth.users.delete-user-message': '刪除 {{count}} 個使用者',
  'project.auth.users.delete-users-message': '刪除 {{count}} 個使用者',
  'project.auth.password.min-length': '最小長度 (6~99)',
  'project.auth.password.require-number': '至少包含 1 個數字',
  'project.auth.password.require-symbol': '至少包含 1 個特殊符號',
  'project.auth.password.require-lowercase': '至少包含 1 個小寫字母',
  'project.auth.password.require-uppercase': '至少包含 1 個大寫字母',
  'project.auth.password': '密碼要求',
  'project.auth.template': '訊息範本',
  'project.auth.template.confirm-with-code': '用驗證碼驗證',
  'project.auth.template.confirm-with-link': '用連結驗證',
  'project.auth.template.subject': '主旨',
  'project.auth.template.message': '內容',
  'project.auth.template.message-with-placeholder': '內容 (必須包含 {{placeholder}})',
  // project.database
  'project.database.all-tables': '所有資料表',
  'project.database.no-database': '沒有資料表',
  'project.database.total-size': '已使用的資料庫空間',
  'project.database.delete-databases': '刪除資料表',
  'project.database.delete-database-message': '刪除已選擇的資料表',
  'project.database.add-database': '新增資料表',
  'project.database.add-database.limit': '資料表數量已達上限',
  'project.database.no-item': '沒有項目',
  'project.database.all-items': '所有項目',
  'project.database.export-to': '匯出',
  'project.database.import-from': '匯入',
  'project.database.delete-items': '刪除所選項目',
  'project.database.delete-item-message': '刪除 {{count}} 個項目',
  'project.database.delete-items-message': '刪除 {{count}} 個項目',
  'project.database.add-item': '新增項目',
  'project.database.edit-item': '編輯項目',
  'project.database.attr.add': '新增值',
  'project.database.attr.string': '純文字',
  'project.database.attr.number': '數字',
  'project.database.attr.boolean': '是非值',
  'project.database.attr.list': '清單',
  'project.database.attr.map': '對應表',
  // project.storage
  'project.storage.all-storages': '所有檔案庫',
  'project.storage.no-storage': '沒有檔案庫',
  'project.storage.total-size': '已使用的檔案空間',
  'project.storage.delete-storages': '刪除檔案庫',
  'project.storage.delete-storage-message': '刪除已選擇的檔案庫',
  'project.storage.add-storage': '新增檔案庫',
  'project.storage.add-storage.limit': '檔案庫數量已達上限',
  'project.storage.no-item': '沒有項目',
  'project.storage.all-files': '所有檔案',
  'project.storage.delete-files': '刪除檔案',
  'project.storage.delete-file-message': '刪除 {{count}} 個檔案',
  'project.storage.delete-files-message': '刪除 {{count}} 個檔案',
  'project.storage.same-file-name': '檔案名稱重複',
  'project.storage.same-file-name-message': '檔案名稱重複，要取代原本的檔案嗎？',
  'project.storage.download-files': '下載檔案',
  'project.storage.download-file-message': '下載 {{count}} 個檔案',
  'project.storage.download-files-message': '下載 {{count}} 個檔案',
  'project.storage.upload-files': '上傳檔案',
  'project.storage.uploading': '上傳中',
  // project.function
  'project.function.all-functions': '所有函式',
  'project.function.no-function': '沒有函式',
  'project.function.add-function': '新增函式',
  'project.function.add-function.limit': '函式數量已達上限',
  'project.function.add-function.use-template': '使用範本',
  'project.function.add-function.use-template.sign-in': '使用 request body 中的使用者名稱和密碼登入',
  'project.function.add-function.use-template.get-item': '使用 ID 獲取一個項目並返回該項目',
  'project.function.delete-functions': '刪除函式',
  'project.function.delete-function-message': '刪除已選擇的函式',
  'project.function.expire-at': 'ID 有效時間',
  'project.function.expire-at.one-day': '1 天',
  'project.function.expire-at.one-week': '7 天',
  'project.function.expire-at.one-month': '30 天',
  'project.function.expire-at.six-months': '180 天',
  'project.function.expire-at.never': '永不過期',
  'project.function.expire-at.description': '過了有效時間後，函式的 ID 無法再被使用，你將會需要更新 ID 來繼續使用這個函式，你可以稍後變更 ID 的有效時間',
  'project.function.expire-at.warning': '建議定期更換新的 ID 以增加安全性',
  'project.function.expired-warning': '你需要更新 ID 來繼續使用這個函式',
  'project.function.size-warning': '函式的大小已達上限',
  'project.function.config': '函式設定',
  'project.function.test.title': '測試函式',
  'project.function.test.template': '測試範例',
  'project.function.test.template-message': '使用以下函式範例測試：',
  'project.function.test.http-method': 'HTTP 方法 (HTTP method)',
  'project.function.test.query-params': '查詢參數 (query params)',
  'project.function.test.headers': '標頭 (headers)',
  'project.function.test.add-header': '新增標頭',
  'project.function.test.body': '主體 (body)',
  'project.function.test.response': '返回結果',
  'project.function.test.status-code': '狀態 (status code)',
  'project.function.test.response.body': '返回內容 (response body)',
  'project.function.config.id-expiration': 'ID 剩餘有效時間',
  'project.function.config.id-description': `在你使用 ${appName} API 的時候，你會需要使用 ID 來指定要執行的函式`,
  'project.function.config.id-regenerate': '變更 ID',
  'project.function.config.id-regenerate.description': '為這個函式產生一個新的 ID',
  'project.function.config.change-expiration': '變更有效時間',
  'project.function.config.auto-save': '自動儲存',
  'project.function.config.auto-save.description': '在你編輯函式的一段時間後自動儲存',
  'project.function.env': '環境變數',
  // project.metric
  'project.metric.api-requests': 'API 使用次數',
  'project.metric.no-data': '沒有數據可以顯示',
  'project.metric.this-month': '本月',
  // project.config
  'project.config.title': '專案設定',
  'project.config.general.title': '一般設定',
  'project.config.danger-zone.title': '危險區',
  'project.config.danger-zone.delete-project': '刪除專案',
  'project.config.danger-zone.delete-project-warning': '刪除專案後，所有與此專案有關的資料都將被刪除。',
  'project.config.danger-zone.delete-project-message': `刪除專案<span class='font-bold'> {{name}} </span>`,

  // settings
  'settings.general.title': '一般設定',
  'settings.general.delete-photo': '刪除照片',
  'settings.general.delete-photo-message': '你確定要刪除照片嗎？',
  'settings.account.title': '帳號設定',
  'settings.plan-and-payments.title': '方案與付款',
  'settings.plan-and-payments.no-plan': '你目前沒有選擇方案',
  'settings.plan-and-payments.cancel-plan': '取消訂閱',
  'settings.plan-and-payments.payment-methods': '付款方式',
  'settings.plan-and-payments.no-payment-methods': '沒有付款方式',
  'settings.plan-and-payments.add-payment-method': '新增付款方式',
  'settings.plan-and-payments.billing-history': '付款紀錄',
  'settings.plan-and-payments.view-billing-history': '查看付款紀錄',

  // pricing
  '/month': '月',
  '/year': '年',
  'pricing.monthly': '月付',
  'pricing.yearly': '年付',
  'pricing.save': '省 {{percent}}%',
  'pricing.title': '方案與定價',
  'pricing.free': '免費版',
  'pricing.upgrade': '訂閱',
  'pricing.free-description': '非常簡單就能開始，為學生或初學者設計',
  'pricing.starter-description': '適合新創企業或個人創業家',
  'pricing.pro-description': '更多空間和彈性的選擇，適合新創企業',
  'pricing.your-current-plan': '你目前的方案',
  'pricing.upgrade-starter': `開始使用 ${appName} Starter`,
  'pricing.upgrade-pro': `開始使用 ${appName}`,
  'pricing.free-limit.apps': '1 個專案',
  'pricing.free-limit.users': '50 個使用者 / 專案',
  'pricing.free-limit.databases': '2 個資料表 / 專案',
  'pricing.free-limit.databases-space': '10 MB 的總資料庫空間',
  'pricing.free-limit.storages': '100 MB 的總檔案儲存空間',
  'pricing.free-limit.api': `5000 次 API 使用次數 / 月`,
  'pricing.free-limit.functions': `5 個函式 / 專案`,
  'pricing.free-limit.function-size': `每個函式的大小不超過 10 KB`,
  'pricing.free-limit.ai': `有限的 AI 使用次數`,
  'pricing.pro-limit.plus': '支援服務',
  'pricing.pro-limit.apps': '10 個專案',
  'pricing.pro-limit.users': '100 萬個使用者 / 專案',
  'pricing.pro-limit.databases': '無限制的資料表 / 專案',
  'pricing.pro-limit.databases-space': '10 GB 的總資料庫空間',
  'pricing.pro-limit.storages': '20 GB 的總檔案儲存空間',
  'pricing.pro-limit.api': `100 萬次 API 使用次數 / 月`,
  'pricing.pro-limit.functions': `無限制的函式數量 / 專案`,
  'pricing.pro-limit.function-size': `每個函式的大小不超過 50 KB`,
  'pricing.pro-limit.ai': `無限制的 AI 使用次數`,

  // docs
  'docs.menu': '目錄',
  'docs.code-title.setup': `設定 ProjectManager`,
  // docs.get-started
  'docs.get-started.menu.title': '快速開始',
  'docs.get-started.menu.create-project': '建立一個專案',
  'docs.get-started.menu.install-sdk': '安裝開發工具',
  'docs.get-started.menu.setup-manager': '建立 ProjectManager',
  'docs.get-started.menu.next-step': '下一步',
  'docs.get-started.section-1': `<p>${appName} 提供了一個簡單的介面及 API 來管理你的使用者、資料庫。遵循本文檔中的步驟來開始學習。`,
  'docs.get-started.section-2': `<p>在登入之後，你可以在主頁新增新專案。在建立一個專案之後，你將會在專案總覽中找到存取專案所需的<span class='text-primary'>專案 ID</span> 和 <span class='text-primary'>API 金鑰</span>，你將可以在你的程式碼中使用它們來存取專案中的服務。</p>`,
  'docs.get-started.section-3': `<p>取得專案 ID 和 API 金鑰之後，就可以在你的後端程式碼中使用 API 來存取你的專案，使用 npm 安裝 ${appName} 的開發工具，並在你的 Node.js 程式碼中開始使用。若你使用 <span class="text-primary">${appName} 函式</span>來管理你的專案後端，則不需要安裝開發工具。</p>`,
  'docs.get-started.section-4': `<p>在程式碼中建立一個<code>ProjectManager</code>，並設定你的<span class="text-primary">專案 ID</span> 和 <span class="text-primary">API 金鑰</span></span>，<code>manager</code>將連接你的專案，你可以用它在你的程式碼中來使用專案中的服務。</p>`,
  'docs.get-started.section-5': `<p>建立一個<code>ProjectManager</code>之後，就可以根據你的需要存取各項服務：</p>`,
  'docs.get-started.code-title.install': '安裝開發工具',
  // docs.auth
  'docs.auth.menu.title': '使用 API 進行身份驗證',
  'docs.auth.menu.signup': '註冊',
  'docs.auth.menu.confirm-signup': '驗證使用者',
  'docs.auth.menu.signin': '登入',
  'docs.auth.menu.forgot-password': '忘記密碼',
  'docs.auth.menu.delete-user': '刪除使用者',
  'docs.auth.section-1': `<p>要使用 API 來處理專案中的使用者身份驗證，你需要：<br /><span class='mx-1'>1. 建立一個專案，該專案將為你建立一個預設的身份驗證系統</span><br /><span class='mx-1'>2. 根據你的需求修改配置，例如密碼要求、Email 訊息等</span><br /><span class='mx-1'>3. 在程式碼中建立一個<code>ProjectManager</code>，並設定你的<span class="text-primary">專案 ID</span> 和 <span class="text-primary">API 金鑰</span></span><br /><span class='mx-1'>4. 使用<code>manager.auth</code>進行使用者的相關操作</span></p>`,
  'docs.auth.section-2': `<p>以下範例使用<code>signUp</code>來註冊使用者，並發送驗證碼到使用者提供的電子郵件：</p>`,
  'docs.auth.section-3': `<p>發送驗證碼到 Email 後，使用者可以在你的應用程式中輸入驗證碼，你將用<code>confirmSignUp</code>來驗證。驗證成功後，使用者會被標註為已驗證，你可以在專案的身份驗證中查看：</p>`,
  'docs.auth.section-4': `<p>已註冊並成功驗證的使用者可以使用<code>signIn</code>來登入，如以下範例：</p>`,
  'docs.auth.section-5': `<p>若是使用者忘記密碼，用<code>forgotPassword</code>函式，指定使用者名稱，我們將會發送一個驗證碼到使用者的 Email，接著利用接收到的驗證碼和<code>confirmForgotPassword</code>函式來設定新的密碼。</p>`,
  'docs.auth.section-6': `<p style="margin-top: 2rem;">輸入驗證碼和新的密碼，使用者的密碼就更新完成</p>`,
  'docs.auth.section-7': `<p>在你的專案中，你可以使用<code>deleteUser</code>來刪除不需要的使用者：</p>`,
  'docs.auth.code-title.signup': `註冊一個使用者`,
  'docs.auth.code-title.confirm-signup': `驗證使用者`,
  'docs.auth.code-title.signin': `登入`,
  'docs.auth.code-title.forgot-password': `忘記密碼`,
  'docs.auth.code-title.reset-password': `重設密碼`,
  'docs.auth.code-title.delete-user': `刪除一個使用者`,
  // docs.database
  'docs.database.menu.title': '存取你的資料庫',
  'docs.database.menu.add': '新增項目到資料庫',
  'docs.database.menu.get': '取得資料庫的項目',
  'docs.database.menu.delete': '從資料庫中刪除項目',
  'docs.database.menu.update': '更新資料庫的項目',
  'docs.database.section-1': `<p>要使用 API 來存取你的資料庫，你需要：<br /><span class='mx-1'>1. 在你的專案中建立一個資料庫</span><br /><span class='mx-1'>2. 在程式碼中建立一個<code>ProjectManager</code>，並設定你的<span class="text-primary">專案 ID</span> 和 <span class="text-primary">API 金鑰</span></span><br /><span class='mx-1'>3. 使用<code>manager.database</code>進行資料庫的相關操作</span></p>`,
  'docs.database.section-2': `<p>使用<code>createItem</code>，並指定資料庫的名稱，你就能新增項目到該資料庫，項目中必須包含參數<code>id</code>。新增項目的<code>id</code>若已存在於資料庫內，則會回傳錯誤。以下範例說明如何新增一個項目到資料庫：</p>`,
  'docs.database.section-3': `<p><code>getItem</code>讓你用<code>id</code>取回資料庫中的一個項目，以下範例說明如何透過指定<code>id</code>取回一個資料庫的項目：</p>`,
  'docs.database.section-4': `<p style="margin-top: 2rem;">使用<code>getItems</code>，你也可以一次回傳資料庫中的多個項目，你可以指定<code>limit</code>和<code>offset</code>來限制回傳的數量和起始位置，如果你沒有指定 limit 和 offset，預設的值是 100 和 0。以下是一個範例：</p>`,
  'docs.database.section-5': `<p style="margin-top: 2rem;">或是使用<code>findItems</code>指定條件來取回特定的一些項目，<code>conditions</code>代表回傳項目的條件，如以下範例：</p>`,
  'docs.database.section-6': `<p>以下是回傳範例，你可以看到範例只回傳符合條件的項目：</p>`,
  'docs.database.section-7': `<p>要刪除資料庫中的項目，使用<code>deleteItems</code>並指定要刪除的項目<code>id</code>，如以下所示：</p>`,
  'docs.database.section-8': '<p>若是要變更部分參數，而不是整個項目的話，可以使用<code>updateItem</code>，<code>changes</code>中包含要變更的參數，如以下所示：</p>',
  'docs.database.section-8.before-update': `更新前：`,
  'docs.database.section-8.after-update': `更新後：`,
  'docs.database.code-title.create-item': `新增一個項目到 Users`,
  'docs.database.code-title.get-item': `從 Users 取得 id 為 user1 的項目`,
  'docs.database.code-title.get-all-items': `取得 Users 的所有項目`,
  'docs.database.code-title.get-some-items': `取得符合特定條件的項目`,
  'docs.database.code-title.delete-item': `刪除 id 為 user3 的項目`,
  'docs.database.code-title.update-item': `變更 user1 的部分參數`,
  // docs.storage
  'docs.storage.menu.title': '使用 API 存取檔案',
  'docs.storage.menu.upload-file': '上傳檔案',
  'docs.storage.menu.download-file': '獲取檔案內容',
  'docs.storage.menu.delete-file': '刪除檔案',
  'docs.storage.section-1': `<p>要存取你的檔案，你需要：<br /><span class='mx-1'>1. 在你的專案中建立一個檔案庫</span><br /><span class='mx-1'>2. 在程式碼中建立一個<code>ProjectManager</code>，並設定你的<span class="text-primary">專案 ID</span> 和 <span class="text-primary">API 金鑰</span></span><br /><span class='mx-1'>3. 使用<code>manager.storage</code>進行檔案的相關操作</span></p>`,
  'docs.storage.section-2': `<p>要將檔案上傳到你的檔案庫中，你可以使用<code>getUploadUrl</code>，取得一個上傳檔案的網址，你可以在你的前端中使用這個網址來上傳檔案，如以下範例：</p>`,
  'docs.storage.section-3': `<p>要取回檔案的內容，你可以使用<code>getFileContentUrl</code>函式，取得一個獲取檔案的網址，用這個網址來獲取檔案的內容：</p>`,
  'docs.storage.section-4': `<p>你也可以使用<code>deleteFile</code>函式來簡單地刪除檔案，如以下所示：</p>`,
  'docs.storage.code-title.upload': `上傳檔案範例`,
  'docs.storage.code-title.get-file-content': `檔案內容以 Blob 形式回傳`,
  'docs.storage.code-title.download': `下載檔案函式`,
  'docs.storage.code-title.delete': `刪除指定檔案`,
  'docs.storage.code-example.file-input': `建立一個 input 元素`,
  'docs.storage.code-example.upload-file': `使用 \`client.storage.uploadFile\` 上傳檔案`,
  'docs.storage.code-example.blob-object': `Blob {size: 12345, type: "image/png"}`,
  'docs.storage.code-example.create-url': `用回傳的 Blob 建立 URL`,
  'docs.storage.code-example.create-link': `建立一個連結並點擊下載`,
  // docs.function
  'docs.function.menu.title': `使用 ${appName} 函式來執行你的後端`,
  'docs.function.menu.setup-code': '設置你的函式',
  'docs.function.menu.use-api': `使用 ${appName} API`,
  'docs.function.menu.call-function': '從外部執行你的函式',
  'docs.function.section-1': `<p>${appName} 函式允許你安全地執行你的後端程式，在專案中建立一個函式，並按照以下步驟來設置。</p>`,
  'docs.function.section-2': `<p>當你在專案中建立一個函式後，你將會獲得一個 Node.js 的範本，如以下所示。<br />在<code>main</code>函式內定義你要執行的任務和返回的結果。</p>`,
  'docs.function.section-3': `<p>你可以使用 ${appName} 函式來驗證使用者的身份、管理資料庫等。如以下範例用函式從資料庫中取得特定的資料：</p>`,
  'docs.function.section-4': `<p>當你設置好函式後，就能在你的前端中用 ${appName} 的 REST API 執行並獲得回傳的結果：<span class="text-primary">https://api.tranfoo.com/<你的專案ID>/function/<你的函式ID></span>。<br/>你會需要使用你的專案 ID 和 函式 ID 來執行。如以下範例使用 REST API 執行上一個範例的函式：</p>`,
  'docs.function.section-5': `<p class="mt-8">查看如何使用函式的完整範例：</p>`,
  'docs.function.code-title.setup-code': '設置你的函式',
  'docs.function.code-title.use-api': `在你的函式中使用 ${appName} API`,
  'docs.function.code-title.call-function': '使用 REST API 執行函式',
  'docs.function.code-example.get-param': '從 params 取得參數 tableName 和 id',
  'docs.function.code-example.get-data': '用 `manager.database.getItem` 取得資料',
  'docs.function.code-example.return-data': '回傳取得的資料',
  // docs.example-1
  'docs.example-1.menu.title': '使用函式獲取資料',
  'docs.example-1.menu.database': '範例：獲取資料庫中的項目',
  'docs.example-1.menu.setup-function': '設置你的函式',
  'docs.example-1.menu.call-function': '在 React 中執行',
  'docs.example-1.section-1': `<p>這個範例展示使用函式作為後端，獲取資料庫中的項目，並在 React 中呼叫函式獲得回傳的資料。</p>`,
  'docs.example-1.section-2': `<p>以下是資料表範例 customers，其中共有三個項目：</p>`,
  'docs.example-1.section-3': `<p>建立一個用來取得所有項目的函式，如以下所示：</p>`,
  'docs.example-1.section-4': `<p>在以下 React 範例中，將專案中複製的專案 ID 和函式 ID 貼上。<br/>在 React 中，<code>items</code> 代表所有項目，在用 fetch 執行函式後，使用<code>setItems</code>來更新<code>items</code>為回傳的資料：</p>`,
  'docs.example-1.section-5': `<p class="mt-8">成功取得資料後，將結果顯示在畫面上，以上 React 範例顯示的結果：</p>`,
  'docs.example-1.code-title.setup-function': '取得所有項目',
  'docs.example-1.code-title.call-function': 'React 範例',
  'docs.example-1.code-example.get-param': '從 params 取得參數 tableName',
  'docs.example-1.code-example.get-data': '用 `manager.database.getAllItems` 取得資料表中的所有項目',
  'docs.example-1.code-example.return-data': '回傳取得的資料',
  'docs.example-1.code-example.use-state': '`items` 代表所有項目',
  'docs.example-1.code-example.fetch-data': '使用 fetch 執行 REST API，並指定 `tableName`',
  'docs.example-1.code-example.set-state': '更新 `items` 為回傳的資料',
}